import {
    DELIVERIES,
    DELIVERIES_SETTINGS,
    LIVEVIEW,
    REPORTS
} from '@core/router/app-states';
import { NavBarItem } from './nav-bar-item';

export const NAV_BAR_ITEMS: NavBarItem[] = [
    {
        label: 'Navbar.Menu.LiveMap',
        state: LIVEVIEW
    },
    {
        label: 'Navbar.Menu.Orders',
        state: DELIVERIES,
        exceptions: [
            DELIVERIES_SETTINGS
        ]
    },
    {
        label: 'Navbar.Menu.Reports',
        state: REPORTS
    }
];